import { render, staticRenderFns } from "./receivingcustomerfrm.vue?vue&type=template&id=6f01b3b7"
import script from "./receivingcustomerfrm.vue?vue&type=script&lang=js"
export * from "./receivingcustomerfrm.vue?vue&type=script&lang=js"
import style0 from "./receivingcustomerfrm.vue?vue&type=style&index=0&id=6f01b3b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports